import { $emailSchema } from './states';
import { fetchEmailSchema } from './effects';

// Fetch email schema
$emailSchema.on(fetchEmailSchema.doneData, (_, data) => data);
